import { portalRoutes } from "@nju/routes";
import { IExtendedOnboardingOrchestratorState } from "./types";

export function resolvePathFromOrchestratorState({
  state,
}: {
  state: IExtendedOnboardingOrchestratorState;
}): string {
  switch (state) {
    case "START":
      return portalRoutes.mojeKonto.index.path();

    case "CONTRACT_VERIFICATION":
      return portalRoutes.weryfikacjaNumeru.index.path();

    case "CONTRACT_VERIFICATION.otp":
      return portalRoutes.weryfikacjaNumeru.otp.path();

    case "IDENTITY":
      return portalRoutes.weryfikacjaTozsamosci.index.path();

    case "IDENTITY.onfido":
      return portalRoutes.weryfikacjaTozsamosci.zdjecieDokumentu.path();

    case "IDENTITY_ERROR":
      return portalRoutes.mojeKonto.index.path();

    case "IDENTITY_PENDING":
      return portalRoutes.mojeKonto.index.path();

    case "PAYMENT_METHOD":
      return portalRoutes.platnosc.index.path();

    case "APPOINTMENT":
      return portalRoutes.terminInstalacji.path();

    case "CONSENTS":
      return portalRoutes.zgody.path();

    case "AGREEMENT_DATA":
      return portalRoutes.daneDoUmowy.path();

    case "AGREEMENT":
      return portalRoutes.umowy.path();

    case "ORDER_SUMMARY":
      return portalRoutes.podsumowanie.path();

    case "DELIVERY":
      return portalRoutes.simCzyEsim.path();

    case "MNP":
      return portalRoutes.migracjaNumeru.typOfertyMobilnej.path();

    case "LEGACY_FEASIBILITY_PENDING":
      return portalRoutes.migracjaNumeru.sprawdzMozliwosc.path();

    case "LEGACY_MIGRATION":
      return portalRoutes.migracjaNumeru.akceptacjaWarunkow.path();

    case "LEGACY_MIGRATION_PENDING":
      return portalRoutes.migracjaNumeru.prawieGotowe.path();

    case "ITEM_SELECTION":
      return portalRoutes.idziemyDalej.path();

    default:
      return portalRoutes.mojeKonto.index.path();
  }
}
